import React, { useState, useCallback } from 'react';
import Layout from '../../components/Layout/PublicLayout/PublicLayout';

import contactPhone from '../../assets/phone-contact.png';
import contactEmail from '../../assets/email-contact.png';
import contactFb from '../../assets/facebook-contact.png';

import koopLogo from '../../assets/koop-draft-logo.png';
import koopHeader from '../../assets/KOOP-header.png';

import activityOne from '../../assets/activity-1.png';
import activityTwo from '../../assets/activity-2.png';
import activityThree from '../../assets/activity-3.png';

import heroImg from '../../assets/hero-img.png';
import news1 from '../../assets/news-1.png';
import news2 from '../../assets/news-2.png';
import news1Mobile from '../../assets/news-1-mobile.png';
import news2Mobile from '../../assets/news-2-mobile.png';
import product1 from '../../assets/product-1.png';
import product2 from '../../assets/product-2.png';
import product3 from '../../assets/product-3.png';
import product4 from '../../assets/product-4.png';
import product5 from '../../assets/product-5.png';
import product6 from '../../assets/product-6.png';
import product7 from '../../assets/product-7.png';
import productIcon1 from '../../assets/productIcon-1.png';
import productIcon2 from '../../assets/productIcon-2.png';
import productIcon3 from '../../assets/productIcon-3.png';
import productIcon4 from '../../assets/productIcon-4.png';
import productIcon5 from '../../assets/productIcon-5.png';
import productIcon6 from '../../assets/productIcon-6.png';
import productIcon7 from '../../assets/productIcon-7.png';
import productIcon8 from '../../assets/productIcon-8.png';
import productIcon9 from '../../assets/productIcon-9.png';
import productIcon10 from '../../assets/productIcon-10.png';
import productIcon11 from '../../assets/productIcon-6.png';

import Accordion from './Accordion.jsx';
import SliderWithThumbs from '../../components/Slider/SliderWithThumbs';
import MainSlider from './MainSlider';
import ThumbSlider from './ThumbSlider';
import ProductListAccordion from './ProductListAccordion';

import { activities } from './activityData';

import homeService from './homeService';
import { EmailFeedbackInput } from '../../interface/IPublic';



const productList = [
	{ icon: productIcon4, label: <>REGULAR LOAN<br />SALARY (ATM)</> },
	{ icon: productIcon3, label: 'SALARY LOAN' },
	{ icon: productIcon1, label: 'EDUCATIONAL LOAN' },
	{ icon: productIcon2, label: 'EMERGENCY LOAN' },
	{ icon: productIcon5, label: 'HOUSING LOAN, PURCHASE OF LOT LOAN' },
	{ icon: productIcon7, label: 'PANDEMIC LOAN' },
	{ icon: productIcon6, label: 'TRAVEL LOAN' },
	{ icon: productIcon4, label: 'RICE LOAN, GIFT CHECKS, CHECK ENCASHMENT' },
	{ icon: productIcon8, class: 'ec-pay', label: 'EC-PAY' },
	{ icon: productIcon11, label: 'FURNITURE, APPLIANCES, GADGETS, COMPUTERS, CELLPHONES AND OTHERS' },
	{ icon: productIcon9, label: 'PHOTOCOPY & PRINTING' },
	{ icon: productIcon10, label: 'PRODUCTIVE LOANS, LIVELIHOOD ENTREPRENEURIAL (PANGKABUHAYAN)' },

];

const slides = [
	{
		content: (
			<div className="container product-1">
				<div className="product-details">
					<h2>Educational Loan</h2>
					<p>You believe in their dreams. We’ll help you fund them.</p>
				</div>
				<img src={product1} alt="Educational Loan" />
			</div>
		),
		thumb: (
			<div className="thumb-box">
				<img src={productIcon1} alt="Educational Loan Icon" />
				EDUCATIONAL
				<br />
				LOAN
			</div>
		),
	},
	{
		content: (
			<div className="container product-2">
				<div className="product-details">
					<h2>Emergency Loan</h2>
					<p>Fast help for urgent financial needs.</p>
				</div>
				<img src={product2} alt="Emergency Loan" />
			</div>
		),
		thumb: (
			<div className="thumb-box">
				<img src={productIcon2} alt="Emergency Loan Icon" />
				EMERGENCY
				<br />
				LOAN
			</div>
		),
	},
	{
		content: (
			<div className="container product-3">
				<div className="product-details">
					<h2>Regular Loan, Salary(ATM)</h2>
					<p>A personal loan with salary-based repayment.</p>
				</div>
				<img src={product3} alt="Regular Loan" />
			</div>
		),
		thumb: (
			<div className="thumb-box">
				<img src={productIcon3} alt="Regular Loan Icon" />

				SALARY<br />(ATM)
			</div>
		),
	},
	{
		content: (
			<div className="container product-4">
				<div className="product-details">
					<h2>Check Encashments</h2>
					<p>Get cash now, pay later in easy terms.</p>
				</div>
				<img src={product7} alt="Rice Loan" />
			</div>
		),
		thumb: (
			<div className="thumb-box">
				<img src={productIcon4} alt="Rice Loan Icon" />
				RICE LOAN, GIFT CHECKS
				<br />
				CHECK ENCASHMENT
			</div>
		),
	},
	{
		content: (
			<div className="container product-5">
				<div className="product-details">
					<h2>Housing Loan & Purchase of Lot Loan</h2>
					<p>Assistance for buying residential land or lots.</p>
				</div>
				<img src={product5} alt="Housing Loan" />
			</div>
		),
		thumb: (
			<div className="thumb-box">
				<img src={productIcon5} alt="Housing Loan Icon" />
				HOUSING LOAN,
				<br />
				PURCHASE OF LOT LOAN
			</div>
		),
	},
	{
		content: (
			<div className="container product-6">
				<div className="product-details">
					<h2>Travel Loan</h2>
					<p>Covers travel costs for work or leisure.</p>
				</div>
				<img src={product6} alt="Travel Loan" />
			</div>
		),
		thumb: (
			<div className="thumb-box">
				<img src={productIcon6} alt="Travel Loan Icon" />
				TRAVEL
				<br />
				LOAN
			</div>
		),
	},

];

const slide = [
	{
		content: (
			<div className="news-item">
				<img src={news1} className="news-web" alt="News 1" />
				<img src={news1Mobile} className="news-mobile" alt="News 1 Mobile" />
			</div>
		),
		thumb: <div className="thumb-box"></div>,
	},
	{
		content: (
			<div className="news-item">
				<img src={news2} className="news-web" alt="News 2" />
				<img src={news2Mobile} className="news-mobile" alt="News 2 Mobile" />
			</div>
		),
		thumb: <div className="thumb-box"></div>,
	},
];

const accordionItems = [
	{
		title: 'How is the loan deducted?',
		content: (

			<div className='deduction-list'>
				<div className='deduction-item'>
					<div className='deduction-value'>
						<span><span>*1.25%</span>PER MONTH</span>
						<span><span>*0.75% </span>EDUCATIONAL LOAN</span>
					</div>
					<div className='deduction-title'>
						Interest on Loan/Diminishing Balance
					</div>
				</div>
				<div className='deduction-item'>
					<div className='deduction-value'>
						<span><span>*2%</span>OF LOANABLE AMOUNT</span>
						<span><span>*3%</span>EDUCATIONAL LOAN</span>
					</div>
					<div className='deduction-title'>
						Service Fee
					</div>
				</div>
				<div className='deduction-item'>
					<div className='deduction-value'>
						<span><span>*2%</span>OF LOANABLE AMOUNT</span>
					</div>
					<div className='deduction-title'>
						Capital Build Up
					</div>
				</div>
			</div >
		),
	},
	{
		title: 'What are the terms of payment?',
		content: (
			<div className='deduction-list'>
				<div className='deduction-item' style={{ width: '100%' }}>
					<div className='deduction-value'>
						<span><span>15th</span>Kinsenas</span>
						<span><span>30th</span>Katapusan</span>
					</div>
					<div className='deduction-title'>
						Salary/Payroll Deduction
					</div>
				</div>

			</div >

		),
	},
	{
		title: 'Who can become a member?',
		content: (
			<div>
				All regular and permanent employees and officials of the Batangas Provincial Government
			</div>),

	},
	{
		title: 'What are the requirements for membership?',
		content: (
			<ol className='list-style'>
				<li>Fill-up the application of “Kasunduan ng pagsapi” attach the photocopy of Letter of Appointment as Regular/Permanent Employee of the Provincial Government of Batangas.</li>
				<li>Pledge to undertake the responsibilities of the members and uphold the by-laws, promulgated by the BODs and General Assembly.</li>
				<li>Pay the required Membership Fee of P200.00</li>
				<li>Subscribe the required ONE SIXTY (160) SHARES and pay the required initial/minimum Share Capital of P4,000,00.</li>
				<li>PATRONIZE the services of KOOPBATANGAN MPC.</li>
			</ol>),
	},
	{
		title: 'What are the duties and responsibilities of a member?',
		content: (
			<ul className='list-style'>
				<li>Pay the installment of his.her share capital subscription as it falls due to participation in the capital build-up and savings mobilization activities of the cooperative.</li>
				<li>Patronize the Cooperative’s business and other services.</li>
				<li>Participate in the membership education programs.</li>
				<li>Attend and participate in the deliberation of all matters taken during General Assembly meetings.</li>
				<li>Obey the rules and regulations provided by RA 9520, these by laws, the decisions of General Assembly and the Board of Directors, and policies and decisions that may be promulgated by Cooperative Development Authority (CDA) and</li>
				<li>Promote the goals and objectives of the cooperative, the success of its business, the welfare of its members and the cooperative movement in general.</li>
			</ul>
		),
	},
	{
		title: 'What rights do members have?',
		content: (

			<ul className='list-style'>
				<li>Participate and vote on all matters deliberated upon during General Assembly Meetings.</li>
				<li>Vote on all matters brought before such meetings.</li>
				<li>Seek any elective or appointive position, subject to the provision of this by laws and the Philippine Cooperative Code RA 9520.</li>
				<li>Avail himself of the services of the cooperative, subject to certain conditions as may be prescribed by the Board Of Directors.</li>
				<li>Inspect and examine the books of accounts, the minute’s books, the shares register, and other records of cooperative during office hours.</li>
				<li>Such other rights and privileges as may be provided by the Board/General Assembly.</li>
			</ul>

		),
	},
	{
		title: 'When is a member entitled to vote?',
		content: (
			<div>
				<ul className='list-style'>
					<li>Paid the membership fee of Two Hundred Pesos Only (P 200.00) and the value of <strong>at least TWENTY FIVE PERCENT (25%)</strong> amount of Share Capital amounting to <strong>FOUR THOUSAND PESOS ONLY (P4,000.00)</strong></li>
					<li>Is not delinquent in the payment of Share Capital subscription and other accounts or obligations.</li>
					<li>Has not violated any provisions of this By Laws, terms and conditions of the subscriptions agreement, and the decisions, guidelines, rules and regulations promulgated by the Board of Directors and the General Assembly.</li>
					<li>Completed the basic orientation training program prescribed by the Board of Directors, and</li>
					<li>Complies with all obligations, duties and undertaking of membership.</li>
				</ul>

			</div>
		),
	},
];

const HomePage = () => {
	const [openAccordion, setOpenAccordion] = useState(false);
	const [thumbsSwiper, setThumbsSwiper] = useState(null);
	const [emailFeedbackInput, setEmailFeedbackInput] = useState<EmailFeedbackInput>({ name: '', feedbackSenderEmail: '', message: '' });

	const handleToggle = useCallback(() => setOpenAccordion((prev) => !prev), []);

	const handleInputChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
			const { name, value } = e.target;
			setEmailFeedbackInput((prev) => ({
				...prev,
				[name]: value,
			}));
		},
		[]
	);

	const handleSendMessage = useCallback(async () => {
		const { name, feedbackSenderEmail, message } = emailFeedbackInput;
		if (name && feedbackSenderEmail && message) {
			await homeService.sendEmailFeedback(emailFeedbackInput);
		} else {
			console.log('fields are required');
		}
	}, [emailFeedbackInput]);


	// Import useNavigate from react-router-dom at the top of your file:
	// import { useNavigate } from 'react-router-dom';
	const navigate = typeof window !== "undefined" ? require('react-router-dom').useNavigate() : () => { };

	// Remove unused ViewEventButtonClick (not used in this component)

	return (

		<Layout>

			<div className="public-banner">
				<div className="container">
					<div className="public-container">
						<div className="public-header">


							<img src={koopHeader} className='hero-header' />


							<p>
								Koop ng mga Kawani ng Pamahalaang Panlalawigan Ny Batangan Multi Purpose Cooperative
							</p>
						</div>
						<img src={heroImg} className="hero-img" alt="Hero" />
					</div>
				</div>
			</div>

			<div id="koop" className="section1 public-section">
				<div className="container">
					<SliderWithThumbs slides={slide} />
				</div>
			</div>

			<div id="activities" className="section2 public-section">
				<div className="container">
					<h2>KOOP Activities</h2>
					<div className="activity-list">
						{activities.map((activity, idx) => (
							<a className="activity-item" key={idx} href={`/Activity/${activity.id}`}

								aria-label={`View more about ${activity.title}`}>
								<div className="activity-image">
									<span>{activity.type}</span>
									<img src={activity.image} alt={activity.type} />
								</div>
								<div className="activity-details">
									<div className="activity-header">
										{activity.title}
										{/* <span>{activity.date}</span> */}
										<p>{activity.desc}</p>
									</div>
									<a
										className="activity-view-more"
									>
										View More
									</a>
								</div>
							</a>
						))}
					</div>
					{/* <a className="blue-btn" href="/Events">
						View All Activities
					</a> */}
				</div>
			</div>

			<div id="products" className="section3 public-section">
				<div className="container">
					<h2>Our Products and Services</h2>
				</div>
				<MainSlider thumbsSwiper={thumbsSwiper} slides={slides} />
				<br />
				<ThumbSlider onThumbsReady={setThumbsSwiper} slides={slides} />
				<div className="container">
					<br />
					<a
						className={`blue-btn${openAccordion ? ' active' : ''}`}
						onClick={handleToggle}
					>
						View All Products and Services
					</a>
					<br />
					<ProductListAccordion isOpen={openAccordion}>
						{productList.map((product, idx) => (
							<div className={`product-item${product.class ? ' ' + product.class : ''}`} key={idx}>
								<img src={product.icon} alt="Product Icon" />
								{product.label}
							</div>
						))}
						<a className="product-item product-item-last" href='#contact-us'>
							<img src={koopLogo} />
							<p className='product-inquiry'>Have Questions?<br /><span>We’re here to help—click me!</span></p>
						</a>

					</ProductListAccordion>

				</div>
			</div>

			<div id="faqs" className="section4 public-section">
				<div className="container">
					<h2>More Information and FAQS</h2>
					<Accordion items={accordionItems} />
				</div>
			</div>

			<div id="contact-us" className="section5 public-section">
				<div className="container">
					<div className="contact-section">
						<h2>We want to hear from you</h2>
						<p>Your message matters to us. Share your details and we’ll respond promptly.</p>
						<div className="contact-info">
							<a href="tel:980-5363" target="_blank" rel="noopener noreferrer">
								<img src={contactPhone} alt="Phone" />
								980-5363/723-5424
							</a>
							<a href="https://www.facebook.com/koopbatangan.multipurposecooperative/" target="_blank" rel="noopener noreferrer">
								<img src={contactFb} alt="Facebook" />
								Koopbatangan MultipurposeCooperative
							</a>
							<a href="mailto:koopbatanganm@yahoo.com.ph" target="_blank" rel="noopener noreferrer">
								<img src={contactEmail} alt="Email" />
								koopbatanganm@yahoo.com.ph
							</a>
						</div>
					</div>
					<div className="contact-form">
						<input
							type="text"
							className="contact-input"
							placeholder="Name"
							name="name"
							value={emailFeedbackInput.name}
							onChange={handleInputChange}
						/>
						<input
							type="email"
							className="contact-input"
							placeholder="Email"
							name="feedbackSenderEmail"
							value={emailFeedbackInput.feedbackSenderEmail}
							onChange={handleInputChange}
						/>
						<textarea
							placeholder="Message"
							className="contact-input"
							name="message"
							value={emailFeedbackInput.message}
							onChange={handleInputChange}
						/>
						<button
							className="blue-btn"
							type="button"
							onClick={handleSendMessage}
						>
							Send Message
						</button>
					</div>
				</div>
			</div>




		</Layout >
	);
};

export default HomePage;